export const event = {
  namespaced: true,
  state: {
    events: [],
  },

  actions: {
    addEvent({ commit }, payload) {
      commit("SET_EVENT", payload);
    },
  },

  mutations: {
    SET_EVENT(state, payload) {
      state.events = [payload].concat(state.events.slice(0, 49));
    },
  },

  getters: {
    lastEvent(state) {
      if (state.events.length <= 0) return {};

      return state.events[0];
    },
  },
};
